import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_ALIAS_BILL_DATA_FIELDS = "GET_ALIAS_BILL_DATA_FIELDS";

export const service = async () => {
  const options: object = {
      url: `/Api/Lookup/GetAliasBillDataFields`,
    method: "GET",
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ALIAS_BILL_DATA_FIELDS, service, mock);
